import React from 'react'
import { MDBContainer, MDBModal, MDBModalBody } from 'mdbreact';
import ListadoAtributos from './modalAtributos/ListadoAtributos'
import ListadoProductosCombos from './modalAtributos/ListadoProductosCombos';


const ModalAtributos = ({ producto, baseUrl, estadoModal, controlModalAtri, listaAtributos, ManejaClickSubeProducto, atributosTerminados, setAtributosTerminados }) => {

	return (
		<React.Fragment>
			<MDBContainer>

				<MDBModal isOpen={estadoModal} toggle={controlModalAtri} fullHeight position="left" className="overflow">
					<div className="container overflow"></div>
					<div className="row sombra">
						<div className="col-8">
							<h4 className="tituloModal">Armar Pedido:</h4>
						</div>
						<div className="col-4 cont_derecho_modal naranja">
							<button onClick={() => ManejaClickSubeProducto(producto, atributosTerminados)} className="btn boton_estandar btn-lg ">¡Ok!</button>
						</div>
					</div>
					<MDBModalBody >

						{producto.atributos.map((item, index) => {

							//busca dentro de nombreAtributos array si dentro de todos
							// el listado de atributos está
							let { nombre } = item
							if (producto.combo === "true") {
								return (<ListadoProductosCombos item={item} key={index} baseUrl={baseUrl} />)
							}
							return (
								<div key={index} className="col-12 sinPadding">

									<div>
										<ListadoAtributos
											lista={item}
											atributosTerminados={atributosTerminados}
											setAtributosTerminados={setAtributosTerminados}
											categoria={nombre}
										/>
									</div>
								</div>
							)

						})}


					</MDBModalBody>
				</MDBModal>
			</MDBContainer>
		</React.Fragment>
	)
}



export default ModalAtributos